import { Button, Text, ProductFeatureSection } from "../../../../src/components";
import * as React from 'react';
export default {
  Button,
  Text,
  ProductFeatureSection,
  React
};